"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _OrbitControls = require("three/examples/jsm/controls/OrbitControls");
var _FlyControls = require("three/examples/jsm/controls/FlyControls");
var _FirstPersonControls = require("three/examples/jsm/controls/FirstPersonControls");
var _camera = _interopRequireDefault(require("./camera"));
var _renderer = _interopRequireDefault(require("./renderer"));
var _eventHub = _interopRequireDefault(require("@/utils/eventHub"));
var ControlsModule = /*#__PURE__*/function () {
  function ControlsModule() {
    var _this = this;
    (0, _classCallCheck2.default)(this, ControlsModule);
    this.setOrbitControls();
    _eventHub.default.on("toggleControls", function (name) {
      _this["set".concat(name, "Controls")]();
    });
  }
  return (0, _createClass2.default)(ControlsModule, [{
    key: "setOrbitControls",
    value: function setOrbitControls() {
      // 初始化控制器
      this.controls = new _OrbitControls.OrbitControls(_camera.default.activeCamera, _renderer.default.renderer.domElement);
      // 设置控制器阻尼
      this.controls.enableDamping = true;
      // 设置自动旋转
      // controls.autoRotate = true;

      this.controls.maxPolarAngle = Math.PI / 2;
      this.controls.minPolarAngle = 0;
    }
  }, {
    key: "setFlyControls",
    value: function setFlyControls() {
      this.controls = new _FlyControls.FlyControls(_camera.default.activeCamera, _renderer.default.renderer.domElement);
      this.controls.movementSpeed = 100;
      this.controls.rollSpeed = Math.PI / 60;
    }
  }, {
    key: "setFirstPersonControls",
    value: function setFirstPersonControls() {
      this.controls = new _FirstPersonControls.FirstPersonControls(_camera.default.activeCamera, _renderer.default.renderer.domElement);
      this.controls.movementSpeed = 100;
      this.controls.rollSpeed = Math.PI / 60;
    }
  }]);
}();
var _default = exports.default = new ControlsModule();